import { CREATE_INGREDIENT, GET_INGREDIENTS } from './ApiConstants';
import api from './ApiHandler';

export const getIngredientsByPage = async (payload: any) => {
  return await api.get(GET_INGREDIENTS, { params: { ...payload } });
};

export const createIngredient = async (payload: any) => {
  return await api.post(CREATE_INGREDIENT, { ...payload });
};
